import { useEffect, useState } from "react";
import { AiOutlineFileSearch } from "react-icons/ai";
import { useAuth } from "../../../../shared/hooks/useAuth";
import { RoundedButton } from "../../../global";
import { useToggle } from "../../../../shared/hooks/useToggle";
import { FeaturesEnum } from "../../../../shared/enums/features.enum";
import { useSearchAnySideBar } from "../../../../shared/hooks/useSideBar";

export const SearchAnyMenu: React.FC = () => {
    const { setShouldOpen, shouldOpen } = useSearchAnySideBar();
    const { user } = useAuth();
    const { isActive, toggle } = useToggle();

    const [canAnySearch, setCanAnySearch] = useState<boolean>(false);

    const toggleLayersSideBarStatus = () => {
        setShouldOpen(!shouldOpen);
        toggle();
    };

    useEffect(() => {
        const allowedActions =
            user.authorizationsByFeatureName[FeaturesEnum.ANY_SEARCH]
                ?.featureAllowedActions;

        setCanAnySearch(
            allowedActions
                ? allowedActions.includes("read") || allowedActions === "*"
                : false
        );
    }, [user]);

    useEffect(() => {
        if (!shouldOpen && isActive) toggle();
    }, [shouldOpen, isActive, toggle]);

    if (!canAnySearch) return null;

    return (
        <RoundedButton
            onClick={toggleLayersSideBarStatus}
            description="BUSCAR CAMADAS"
            active={isActive}
        >
            <AiOutlineFileSearch size={40} className="inline-block" />
        </RoundedButton>
    );
};
